import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import XHR from 'i18next-http-backend'
import languageEN from './locale/en/translate.json'
import languageDE from './locale/de/translate.json'
import { getBrowserLocales } from './utils/languageHelper'

const browserLocales = getBrowserLocales({languageCodeOnly: true})
i18n
.use(XHR)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources: {
        en: languageEN,
        de: languageDE
    },
    lng: browserLocales[0],
    fallbackLng: "de",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    supportedLngs: ['de', 'en'],
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;